import React from 'react';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { apiPost } from '../../../api/client';
import { Button } from '../../../components/ui/Button';
import { Section } from '../../../components/ui/Section';
import { useSetSetupCompleted } from '../../../api/useSetupConfig';

export default function AdminActionsSection() {
  const clearCacheMutation = useMutation({
    mutationFn: () => apiPost('/user-settings/admin/cache-clear', {}),
    onSuccess: () => toast.success('Cache svuotata'),
    onError: (e: Error) => toast.error(e.message),
  });

  const gcalSyncMutation = useMutation({
    mutationFn: () => apiPost('/user-settings/admin/gcal-sync', {}),
    onSuccess: () => toast.success('Sync Google Calendar completata'),
    onError: (e: Error) => toast.error(e.message),
  });

  const setupMutation = useSetSetupCompleted();

  const handleRerunSetup = () => {
    setupMutation.mutate(false, {
      onSuccess: () => toast.success('Setup wizard riavviato'),
    });
  };

  return (
    <Section title="Azioni" collapsible defaultOpen={false}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
        <p style={{ fontSize: 'var(--text-sm)', color: 'var(--color-text-muted)' }}>
          Azioni amministrative sull'applicazione.
        </p>
        <div style={{ display: 'flex', gap: '0.625rem', flexWrap: 'wrap' }}>
          <Button variant="secondary" size="sm" onClick={() => clearCacheMutation.mutate()} loading={clearCacheMutation.isPending}>
            Svuota cache applicativa
          </Button>
          <Button variant="secondary" size="sm" onClick={() => gcalSyncMutation.mutate()} loading={gcalSyncMutation.isPending}>
            Forza sync Google Calendar
          </Button>
          <Button variant="secondary" size="sm" onClick={handleRerunSetup} loading={setupMutation.isPending}>
            Riesegui Setup iniziale
          </Button>
        </div>
      </div>
    </Section>
  );
}
